import type { Patrol, Person } from '@local/common-lib';
import { Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';

export const roundTimeToMinute = (when: DateTime): DateTime =>
  DateTime.fromObject(
    {
      day: when.day,
      hour: when.hour,
      minute: when.minute,
      month: when.month,
      second: 0,
      year: when.year,
    },
    { zone: when.zone },
  );

export const roundDownFiveMinutes = (when: DateTime): DateTime =>
  roundTimeToMinute(when.minus({ minutes: when.minute % 5 }));

export const personRenderer = (person: Person.View): JSX.Element => (
  <Box
    alignItems="center"
    display="flex"
    flexGrow={1}
    justifyContent="space-between"
  >
    <Typography>
      {person.firstName} {person.lastName.toUpperCase()}
    </Typography>
    <Typography sx={{ color: 'text.secondary', ml: 2 }}>
      {person.phone}
    </Typography>
  </Box>
);

export const guestRenderer = (guest: Patrol.GuestAssignment): JSX.Element => (
  <Box
    alignItems="center"
    display="flex"
    flexGrow={1}
    justifyContent="space-between"
  >
    <Typography>{guest.name}</Typography>
    {guest.phone ? (
      <Typography sx={{ color: 'text.secondary' }}>{guest.phone}</Typography>
    ) : undefined}
  </Box>
);
